"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectCapture = void 0;
const base_1 = require("./base");
class IkeObjectCapture extends base_1.IkeRestObject {
    constructor() {
        super();
        this.className = 'Capture';
        this.actionName = 'capture';
        this.cacheKeys['uuid'] = true;
    }
}
exports.IkeObjectCapture = IkeObjectCapture;
//# sourceMappingURL=capture.object.js.map